import React, { useState } from "react";

import yourBlueprintLogo from "../../images/your-blueprint-logo.png"
import Cta from "../tsx-components/cta"
import { ExternalLinkYellow } from "../tsx-components/icons"
import { StaticImage } from "gatsby-plugin-image";
import ismIconBlueprintCard99 from "../../images/ism-icon-blueprint-card-99.svg"
import ismIconBlueprintCard0 from "../../images/ism-icon-blueprint-card-0.svg"


const BlueprintBlock = () => {

  return (
    <div className="card-blueprint">
        <p className="card-blueprint-header">Access and support are available for your patients taking AYVAKIT</p>
        <div className="card-blueprint-logo-wrapper">
          <div className="card-blueprint-logo">
            <img src={yourBlueprintLogo} alt="YourBlueprint® logo" />
          </div>
          <div className="card-blueprint-logocopy"><span className="font-bold">YourBlueprint®</span> may be able to help your eligible patients access AYVAKIT&mdash;enroll your patients at time of prescription to support the patient experience through our programs.</div>
        </div>

        <div className="card-blueprint-content">
          <div className="card-blueprint-content-col">
            <p>AYVAKIT has broad national coverage</p>
            <div className="card-blueprint-imgwrapper ninety-nine-wrapper">
            <img
              src={ismIconBlueprintCard99}
              alt="99 percent"
            />
            <div>
              <p className="card-blueprint-paragraph"><b>
                Over <span>99</span>% of commercial insurance plans and <span>99</span>% of Medicare plans cover AYVAKIT*</b>
              </p>
              <p className="footnote">
                <span className="aster">*</span>
                <span>
                Data on coverage are as of December 2024.
                </span>
              </p>
            </div>
            </div>
          </div>

          <div className="card-blueprint-content-col">
            <p className="copay-header">Co-pay Assistance Program</p>
            <div className="card-blueprint-imgwrapper">
              <img
                src={ismIconBlueprintCard0}
                alt="$0"
              />
              <div>
                <p className="card-blueprint-paragraph">
                  <b>Approximately <span>90</span>% of patients with commercial insurance paid $0 per month</b><sup><b>†</b></sup> with help from their insurance and with the YourBlueprint&reg; Co-Pay Card<sup>‡</sup> when they accessed AYVAKIT through our network of specialty pharmacies.<sup>§</sup>
                </p>
                <p className="footnote">
                  <span className="dagger">†</span>
                  <span>
                  Data on co-pay assistance are as of December 2024. Cost-sharing data are for those patients with commercial insurance.
                  </span>
                </p>
                <p className="footnote">
                  <span className="dagger">‡</span>
                  <span>
                  Up to an annual maximum benefit of $25,000. Terms and conditions apply.
                  </span>
                </p>
                <p className="footnote">
                  <span className="dagger">§</span>
                  <span>
                  This program covers co-pay, co-insurance and deductible expenses for those who qualify.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <Cta
            href="https://yourblueprint.com/hcp/financial-assistance/"
            target="_blank"
            className="theme-cta theme-cta--external"
          >
            <span className="text-center">EXPLORE PATIENT SUPPORT</span>
            <ExternalLinkYellow />
        </Cta>
    </div>
  );
};

export default BlueprintBlock;
